import React, { useEffect } from "react";
import { StartActivity, sleep } from "../../../../common/common";
import * as CommonFunctions from "../functions/commonFunctions";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import $ from "jquery";

function KoppelenWerkbron() {
  useEffect(() => {
    $("#koppelen_werkbron").on("show.bs.modal", async function (event) {
      var model = {
        content: [
          {
            key: "algemeen-actief",
            and_or: "AND",
            values: [true],
            datatype: "BOOLEAN",
          },
        ],
        definitions: [process.env.REACT_APP_CATALOG_WORK_RESOURCES],
      };

      let result = await omnimap.FillTableAction(
        model,
        1,
        window.$catalog_management_units_token
      );

      CallBackFunctions.WorkResourcesCallBack(result);
    });
  });

  const handleSubmit = () => {
    $("#cover-spin").show(0);
    var budgetId = $("input[name=work-resource]:checked").attr("id");
    var element = $("input[name=work-resource]:checked");
    var label = $(element).next("label").attr("for", budgetId);
    var model = {
      datum: "2020-12-01T12:00:00.001Z",
      werkbron: {
        identification: budgetId,
        display: [{ path: "$.name", value: label }],
      },
    };
    var selectedIds = [];
    $("#example")
      .dataTable()
      .$("tr.selected")
      .each(function () {
        selectedIds.push($(this).attr("rowId"));
      });

    StartActivity(
      model,
      selectedIds,
      "16514ed7-9d02-47ec-bc93-6cf6b15225b4",
      budgetVerplaatst,
      window.$catalog_management_units_token
    );
  };

  function budgetVerplaatst() {
    sleep(500).then(() => {
      $("#koppelen_werkbron").modal("hide");
      $("#cover-spin").hide(0);
      window.$catalog_measures_refresh();
      /*omnimap
        .FillTableAction(
          window.$catalog_measures_last_used_table_filter,
          1,
          window.$catalog_management_units_token
        )
        .then((result) => {
          CallBackFunctions.FillTableCallBack(result, 1);
        });*/
    });
  }

  return (
    <div
      className="modal fade"
      tabIndex={-1}
      role="dialog"
      id="koppelen_werkbron"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Selecteren werkbron</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            <input
              type="search"
              className="modal-search"
              placeholder="Zoeken naar werkbron"
            />
            <div className="modal-scroll">
              <div id="koppelen-werkbron-grp" className="radio-grp" />
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              id="save_budget"
              className="btn-modal"
              onClick={handleSubmit}
            >
              Verwerken
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default KoppelenWerkbron;
